"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetParty = void 0;
const retrommo_types_1 = require("retrommo-types");
const Party_1 = require("../classes/Party");
const definables_1 = require("definables");
const updateWorldCharacterPosition_1 = require("./updateWorldCharacterPosition");
const resetParty = (partyID) => {
    const party = (0, definables_1.getDefinable)(Party_1.Party, partyID);
    const partyLeaderPlayer = party.players[0];
    if (typeof partyLeaderPlayer === "undefined") {
        throw new Error("No party leader character.");
    }
    for (const partyPlayer of party.players) {
        if (partyPlayer !== partyLeaderPlayer) {
            (0, updateWorldCharacterPosition_1.updateWorldCharacterPosition)(partyPlayer.worldCharacterID, partyLeaderPlayer.worldCharacter.position);
            partyPlayer.worldCharacter.direction = retrommo_types_1.Direction.Down;
            partyPlayer.worldCharacter.step = retrommo_types_1.Step.Right;
        }
    }
};
exports.resetParty = resetParty;
